import React from "react";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <section className="yprivacy-policy">
      <div className="yprivacy-container">

        <h1 className="yprivacy-title">Privacy Policy</h1>

        <p className="yprivacy-intro">
          This Privacy Policy describes how your personal information is
          collected, used, and protected when you visit or book pilgrimage
          services through <strong>Muktinath Darshan</strong> website.
          We are committed to protecting your privacy while providing safe
          and reliable travel services for Muktinath Yatra and other
          religious tours.
        </p>

        {/* PERSONAL INFORMATION */}
        <h2>PERSONAL INFORMATION WE COLLECT</h2>

        <p>
          When you visit our website, we automatically collect certain
          information about your device including browser type,
          IP address, time zone, and website interaction data.
          This information helps us improve our services and user experience.
        </p>

        <p>We collect information using the following technologies:</p>

        <ul>
          <li>
            <strong>Cookies:</strong> Used to remember your preferences,
            booking selections and improve website functionality.
          </li>

          <li>
            <strong>Log Files:</strong> Track website usage such as pages
            visited, referring websites, and access times.
          </li>

          <li>
            <strong>Tracking Tools:</strong> Analytics and marketing tools
            may be used to understand visitor behavior and improve services.
          </li>
        </ul>

        <p>
          When you make a booking or enquiry for Muktinath Darshan or other
          travel packages, we may collect:
        </p>

        <ul>
          <li>Name</li>
          <li>Email address</li>
          <li>Mobile number</li>
          <li>Passport or ID details (if required for Nepal travel)</li>
          <li>Travel dates and passenger details</li>
          <li>Payment information</li>
        </ul>

        <p>
          This information is referred to as <strong>Booking Information</strong>.
        </p>

        {/* HOW WE USE INFO */}
        <h2>HOW WE USE YOUR INFORMATION</h2>

        <p>We use your personal information to:</p>

        <ul>
          <li>Process Muktinath Yatra bookings</li>
          <li>Arrange hotels, flights, permits, and transportation</li>
          <li>Confirm reservations and send travel updates</li>
          <li>Provide customer support</li>
          <li>Prevent fraud or unauthorized transactions</li>
          <li>Improve website services and user experience</li>
        </ul>

        {/* SHARING */}
        <h2>SHARING YOUR PERSONAL INFORMATION</h2>

        <p>
          We may share necessary information with trusted third parties only
          for completing travel services, including:
        </p>

        <ul>
          <li>Hotels and accommodation providers</li>
          <li>Airlines and transportation partners</li>
          <li>Nepal travel authorities for permits</li>
          <li>Payment gateway providers</li>
        </ul>

        <p>
          We never sell or rent your personal information to third parties.
        </p>

        {/* ADVERTISING */}
        <h2>MARKETING & COMMUNICATION</h2>

        <p>
          With your consent, we may send promotional emails, offers,
          pilgrimage updates, or special tour packages.
          You can unsubscribe anytime using the unsubscribe link
          provided in our emails.
        </p>

        {/* DATA SECURITY */}
        <h2>DATA SECURITY</h2>

        <p>
          We implement appropriate security measures to protect your
          personal data against unauthorized access, alteration,
          disclosure, or destruction.
        </p>

        {/* DATA RETENTION */}
        <h2>DATA RETENTION</h2>

        <p>
          We retain booking and transaction information only as long
          as necessary for operational, legal, and accounting purposes.
        </p>

        {/* MINORS */}
        <h2>MINORS</h2>

        <p>
          Our services are not intended for individuals under the age of 18
          without parental or guardian supervision.
        </p>

        {/* POLICY CHANGES */}
        <h2>CHANGES TO THIS POLICY</h2>

        <p>
          We may update this Privacy Policy periodically to reflect
          operational or legal changes. Updated versions will be posted
          on this page.
        </p>

        {/* CONTACT */}
        <h2>CONTACT US</h2>

        <p>
          If you have any questions regarding this Privacy Policy,
          please contact us:
        </p>

        <address>
          <strong>Muktinath Darshan</strong><br />
          India & Nepal Pilgrimage Tour Services<br />
          Email: <a href="mailto:info@muktinathdarshan.com">
            info@muktinathdarshan.com
          </a>
        </address>

      </div>
    </section>
  );
};

export default PrivacyPolicy;